import Constants from "./RedoConstants";

let initialState = {
  RedoPackages: [],
  RedoFqa: [],
  RedoForm: {},
  redoOtpSuccess: {},
  redoOtpFailed: {},
  whtsappOtpResponse: {},
};

export default function RedoReducers(state = initialState, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case Constants.ACTIONS.GET_REDO_FAQ:
      newState.RedoFqa = action.payload;
      break;
    case Constants.ACTIONS.GET_REDO_PACKAGES:
      newState.RedoPackages = action.payload;
      break;
    case Constants.ACTIONS.POST_LEAD_USER_SUCCESS:
      newState.RedoForm = action.payload;
      break;
    case Constants.ACTIONS.REDO_OTP_VERIFY_SUCCESS:
      newState.redoOtpSuccess = action.payload;
      break;
    case Constants.ACTIONS.REDO_OTP_VERIFY_FAILED:
      newState.redoOtpFailed = action.payload;
      break;
    case Constants.ACTIONS.WHATSAPP_OTP_RESPONSE:
      newState.whtsappOtpResponse = action.payload;
      break;
    case Constants.ACTIONS.CLEAR_OTP_RES:
      newState.redoOtpSuccess = {};
      break;
    default:
      break;
  }
  return newState;
}
